import React from 'react';
import { connect } from 'react-redux';
import { IState } from '../state/State';
import SignedInLoginBody from './SignedInLoginBody';
import SignedOutLoginBody from './SignedOutLoginBody';
import { ILogInType } from '../actions/LogInActions';

export interface ILoginBodyProps {
  logInState: ILogInType;
}

const LogInBody: React.FC<ILoginBodyProps> = React.memo((props: ILoginBodyProps) => {
    const isUserSignedIn: boolean = props.logInState.accessToken != null;
    
    if (isUserSignedIn) {
      return <SignedInLoginBody />;
    } else {
      return <SignedOutLoginBody />;
    }
});

const mapStateToProps = (state: IState) => ({
  logInState: state.logIn.result
});
  
export default connect(mapStateToProps)(LogInBody);
